
import {Component, Prop, Vue, Inject} from "vue-property-decorator";
import ServiceContainer from "@flashpointbv/solar-service-container";

@Component({
  name: 'service-item',
  components: ServiceContainer().getComponents(),
})
export default class ProductServices extends Vue {
  @Prop({required: true}) readonly service: object;

  @Inject('serviceProductSku') readonly productSku: string;
  @Inject('serviceIndex') readonly index: number;

  private get selectedProductServices(): boolean {
    return this.$store.getters['ProductServices/selectedProductServices'][this.index][this.productSku];
  }
}
